export const VERIFY_USER = 'VERIFY_USER'
export const VERIFY_USER_ERR = 'VERIFY_USER_ERR'
export const RESET_VERIFY_USER = 'RESET_VERIFY_USER'